import { useTranslation } from 'react-i18next';
import type { RankingReport } from '@/queries/cpmRanking';
import { useRankingParticipantCopy } from '@/i18n/rankingParticipant';
import { rankingCountedViews, rankingReportStatus } from '@/lib/campaigns/rankingPresentation';
import { rankingTrackedViews } from '@/lib/campaigns/summarizeRankingViews';
import { formatTimezoneLabel } from '@/lib/format/timezone';

export function RankingClipViews({ report, timezone }: { report: RankingReport; timezone: string }) {
  const { i18n } = useTranslation();
  const copy = useRankingParticipantCopy();
  const locale = i18n?.resolvedLanguage || i18n?.language;
  const tracked = rankingTrackedViews(report);
  const counted = rankingCountedViews(report);
  const status = rankingReportStatus(report);
  const capturedAt = tracked !== null && report.tracked_views_captured_at && Number.isFinite(Date.parse(report.tracked_views_captured_at)) ? report.tracked_views_captured_at : null;
  const format = (value: string | null) => value === null ? '—' : BigInt(value).toLocaleString(locale);
  return <div className="space-y-2">
    <dl className="grid gap-3 sm:grid-cols-2">
      <div><dt className="text-xs text-muted-foreground">{copy.clipTrackedViews}</dt><dd className="font-semibold tabular-nums break-words">{format(tracked)}</dd></div>
      <div><dt className="text-xs text-muted-foreground">{copy.rankingViews}</dt><dd className="font-semibold tabular-nums break-words">{format(counted)}</dd></div>
    </dl>
    <p className="text-xs text-muted-foreground">{status === 'pending' ? copy.pendingClipViewsHelp : status === 'rejected' ? copy.rejectedClipViewsHelp : counted === null ? copy.approvedViewsUnavailable : copy.approvedClipViewsHelp}</p>
    {tracked === null && <p className="text-xs text-muted-foreground">{copy.trackedViewsUnavailable}</p>}
    {report.tracked_views_source === 'public_observation' && <p className="text-xs text-muted-foreground">{copy.publicViewsUnverified}</p>}
    {capturedAt && <p className="text-xs text-muted-foreground">{copy.viewsCapturedAt}{' '}<time dateTime={capturedAt}>{new Date(capturedAt).toLocaleString(locale, { timeZone: timezone, dateStyle: 'short', timeStyle: 'short' })}</time>{' '}({formatTimezoneLabel(timezone)})</p>}
  </div>;
}
